var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopFromOurAdvertisersPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1208,
  height: 360,
  viewBox: "0 0 1208 360",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 1208,
  y1: 1.37012,
  x2: -4.37115e-8,
  y2: 1.37001,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.8701,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 63.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 219.87,
  width: 216,
  height: 92,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 323.87,
  width: 216,
  height: 36,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 63.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 219.87,
  width: 216,
  height: 92,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 323.87,
  width: 216,
  height: 36,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 63.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 219.87,
  width: 216,
  height: 92,
  fill: "#E5E5E5"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 323.87,
  width: 216,
  height: 36,
  fill: "#E5E5E5"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 63.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 219.87,
  width: 216,
  height: 92,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 323.87,
  width: 216,
  height: 36,
  fill: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 63.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 219.87,
  width: 216,
  height: 92,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 323.87,
  width: 216,
  height: 36,
  fill: "#E5E5E5"
})));
export default SvgDesktopFromOurAdvertisersPlaceholder;